import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { Edit, SecurityOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import DefaultRoleBadge from '@/components/DefaultRoleBadge/DefaultRoleBadge';
import { checkPermission } from '@/views/Facilities/CheckPermissions';
import useCurrentUser from '@/hooks/useCurrentUser';

const FacilityUserRoleColumn = ({ user, onChangeRole }) => {
  const { t } = useTranslation();
  const { isAdmin } = useCurrentUser();

  const hasCustomPermissions =
    !user.role_id || user.role_name === 'Custom Permissions';
  const displayName = hasCustomPermissions
    ? t('common.customPermissions', 'Custom Permissions')
    : user.role_name;

  const canWrite = checkPermission({
    parentKey: 'facility_user_management',
    childKey: 'facility_user_management',
    permission: 'write',
  });

  const showEditButton = !isAdmin && canWrite && onChangeRole;

  const role = user.role_id
    ? { name: user.role_name, is_default: user.role_is_default }
    : null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <SecurityOutlined sx={{ fontSize: 18, color: 'primary.main' }} />
        <Typography variant='body2'>{displayName}</Typography>
      </Box>
      <DefaultRoleBadge role={role} />
      {showEditButton && (
        <Tooltip title={t('internalUsers.changeRole', 'Change Role')}>
          <IconButton
            size='small'
            onClick={(e) => {
              e.stopPropagation();
              onChangeRole(user);
            }}>
            <Edit fontSize='small' />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default FacilityUserRoleColumn;
